<template>
  <div class="right_body">
    <!--查询条件-->
    <prod-order-sch-form
      @subSearch="subSearch"
      :fromData="fromData"
    ></prod-order-sch-form>  

    <!-- 操作按钮  -->
    <tool-bar
    ref="actionbtn"
    :searchResultData="searchResultData"
    :sdata="sdata"
    @detail="goDetail"
    @edit="onEditProdOrder"
    @del="del"
    @restore="restore"
    isEdit
    isDelStatu
    ></tool-bar>

    <!--查询结果-->
    <prod-order-search-result
      :tabList="searchResultData"
      :total="total"
      :pages="pages"
      :fromData="fromData" 
      :columns="tabColumns"
      tabName="product_order_search"
      @currentChange="onCurrentChangePage"
      @changePages="onChangePageSize"
      @selectSdata="selectSdata"
      @dbClick="onSelectedRow"
    ></prod-order-search-result>

    <!-- 详情 -->
    <el-dialog
      title="订单明细"
      :visible.sync="dialogFormVisible"
      customClass="dialog_detail_style"
      v-dialogDrag
      @closed="closedDialog"
    >
      <v-detail :sdata="detailSdata" class="contnet_box"></v-detail>
    </el-dialog>
  </div>
</template>

<script>
import { queryOrder } from "api/business.js";
import ToolBar from "components/btn/listBtn.vue";
import ProdOrderSearchResult from "components/table/productionList.vue";
import ProdOrderSchForm from "./components/ordersearch/ProdOrderSchForm.vue";
import vDetail from "./productionDetail.vue";
import dialogDetail from 'components/common/detail.vue';
import { productOrder as productOrderUrl } from "api/business.js";
import { productOrder } from "api/business.js";


export default {
  components: {
    ProdOrderSchForm,
    ToolBar,
    ProdOrderSearchResult,
    vDetail,
    dialogDetail
  },
  data() {
    return {
      loading:true,
      isComponentChild:false,
      dialogFormVisible: false,
      detailSdata: [],
      sdata: {},
      searchResultData: [],
      tabColumns: [
        {
          field: "productOrderNo",
          title: "生产订单号",
          need: true,
          width: 160,
          sortable: true
        },
        { field: "planFactoryDesc", title: "工厂描述", width: 100},
        { field: "inventoryDesc", title: "库存地" },
        { field: "materialCode", title: "物料编码", width: 100 },
        { field: "materialDesc", title: "物料描述" },
        { field: "optionalBom", title: "BOM版本" },
        { field: "createDate", title: "创建日期" ,sortable: true},
        { field: "orderQuantityTotal", title: "总数量" },
        { field: "deliveryQty", title: "已交货数（入库数）",width:150 },
        { field: "orderConfirmScrap", title: "报废数量" },
         {field: 'delId', title: '状态',
        formatter: function (rowData,rowIndex,pagingIndex,field) {
          return rowData.delId === '0011' ? "已删除" : "正常";
        }
        }
      ], 
      //表头字段
			delId:[
				{
					text:'正常',
					value:''
				},
				{
					text:"已删除",
					value:"0011"
				}
			],
      //表头字段
      total: 0, //总条数
      pages: 0, //总页数
      fromData: {
        page: 1, //当前页
        pageSize: 20, //每页显示的数量,
        searchCriteria: {
          //查询的附加条件
        }
      },
      sfromData: {
        //productOrderId: 0,
        productOrderNo: 0
      }
    };
  },
  created() {
    this.getStartData();
  },
  mounted(){
    this.isComponentChild = true;
  },
  methods: {
    //双击
    onSelectedRow(data) {
      this.sdata = data;
      this.goDetail();
    },
    //选中数据
    selectSdata(data) {
      console.log(data);
      this.sdata = data;
      this.sfromData.productOrderId = data.productOrderId;
      this.sfromData.productOrderNo = data.productOrderNo;

    },
    //获取列表
    // async getStartData() {
    //   //生产订单列表
    //   let ProductionOrderList = await this.$post(
    //     productOrder.list,
    //     this.$store.state.getAllPage
    //   );
    //   if (ProductionOrderList.status) {
    //     console.log(ProductionOrderList);
    //     this.searchResultData = ProductionOrderList.data.list;
    //   } else {
    //     alert("错误");
    //   }
    // },


    //获取列表
    async getStartData() {
      console.log(this.fromData)
      //生产订单列表
      let ProductionOrderList = await this.$post(productOrder.list, this.fromData);
      console.log(ProductionOrderList);
      if (ProductionOrderList.status && ProductionOrderList.data) {
        this.pages = ProductionOrderList.data.pages;
        this.searchResultData = ProductionOrderList.data.list;
        this.total = ProductionOrderList.data.total;
      } else {
        this.pages = 0;
        this.searchResultData = [];
        this.total = 0;
      }
    },


    /**
     * 触发查询当前的页数据
     */
    onCurrentChangePage(currentPage) {
      this.fromData.page = currentPage;
      this.getStartData();
    },
    /**
     * 调整页面大小
     */
    onChangePageSize(pagesSize) {
      this.fromData.page = 1;
      this.fromData.pageSize = pagesSize;
      this.getStartData();
    },
    /**
     * 提交搜索
     */
    subSearch() {
      console.log(this.fromData);
      this.fromData.page = 1;
      this.getStartData();
    },
    /**
     * 编辑生产订单
     */
    onEditProdOrder() {
      if (!this.sdata.productOrderNo) {
        this.$message.error("请选择需要编辑的记录");
        return;
      }
      if (this.sdata.delId === "0011") {
        this.$message.error("该条数据已删除，不允许编辑！");
        return;
      }
      // this.$router.push({name: "business-production-orderNewRevise",params: { id: this.sdata.productOrderNo }});
      this.$keepAliveManager.pushRouter(this,{name: "business-production-orderNewRevise",params: { id: this.sdata.productOrderNo }});
    },
    handleSelectChange(item, key) {
      if (item.isChecked) {
        item.isChecked = false;
        this.sdata = {};
      } else {
        this.sdata = item;
        this.sdata.index = key;
        item.isChecked = true;
        this.searchResultData.forEach(items => {
          if (items.productOrderNo != item.productOrderNo) {
            items.isChecked = false;
          }
        });
        if (item.delId === "0011") {
          this.sdata.isDel = true;
        } else {
          this.sdata.isDel = false;
        }
      }
    },
    //选择的改变
    changeSelect(val, item, key) {
      this.handleSelectChange(item, key);
    },
    //详情
    async goDetail() {
      if (!this.sdata.productOrderNo) {
        this.$message.error("请选择要查看的记录");
        return;
      }
      let res = await this.$post(productOrder.find, {productOrderNo:this.sdata.productOrderNo});
      this.dialogFormVisible = true;
      console.log(res.data);
      if (res.status)
       this.detailSdata = res.data.details;
    },
    //关闭弹出层
    closedDialog() {
      this.dialogFormVisible = false;
    },
    //删除
    del() {
      let vm = this;
      console.log(vm.sdata.productOrderId)
      if (!this.sdata.productOrderId) {
        this.$message.error("请选择需要删除的");
        return;
      }
      this.$confirm("确定删除这条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await vm.$get(productOrder.del, {
            productOrderId: this.sdata.productOrderId
          });
          const { data, msg, status, code } = res;
          if (status) {
            this.sdata.delId = '0011';
            this.searchResultData[this.sdata.index] = this.sdata;
            vm.$message.success("操作成功");
          } else {
            vm.$message.error("操作失败");
          }
        })
        .catch(() => {
          this.$message.success("已取消删除");
        });
    },
    //恢复删除
    restore() {
      //alert("暂无恢复删除接口")
      let vm = this;
      if (!this.sdata.productOrderId) {
        this.$message.error("请选择需要恢复的物料");
        return;
      }
      this.$confirm("恢复此条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let res = await vm.$get(productOrder.restore, {
          productOrderId: this.sdata.productOrderId
        });
        const { data, msg, status, code } = res;
        if (status) {
         
         this.sdata.delId = '';
         this.searchResultData[this.sdata.index] = this.sdata;
          vm.$message.success("操作成功");
          
           
        } else {
          vm.$message.error("操作失败");
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>

</style>
